var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_186_2323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9625 18.1407L22.8727 22.8657C22.7196 23.5336 22.1325 24.001 21.4448 24.001C9.61875 24 0 14.3813 0 2.55472C0 1.86753 0.467297 1.27972 1.13531 1.12738L5.86031 0.0375318C6.54844 -0.121937 7.25156 0.235251 7.5375 0.886907L9.71813 5.97284C9.97303 6.57191 9.80109 7.26988 9.29719 7.68144L6.77344 9.70784C8.36625 12.9525 11.0044 15.5907 14.25 17.1844L16.3162 14.6625C16.7235 14.1572 17.4267 13.9824 18.0258 14.2418L23.1117 16.422C23.7234 16.7438 24.1219 17.4563 23.9625 18.1407Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_2323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4d466b15d4f65160783eb37dfb9244b1.svg";
export { ForwardRef as ReactComponent };